module.exports = __webpack_public_path__ + "img/ITA.3b0bc717.svg";